import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export const LanguageDetector: React.FC = () => {
  const { i18n, ready } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (!ready) return; // Wait for i18n to be ready
    
    // Detect language from current path
    const isEnglishPath = location.pathname.startsWith('/en');
    const detectedLanguage = isEnglishPath ? 'en' : 'it';
    
    // Only change language if it's different from current
    if (i18n.language !== detectedLanguage) {
      console.log('Changing language to:', detectedLanguage);
      i18n.changeLanguage(detectedLanguage);
    }
  }, [location.pathname, i18n, ready]);

  return null; // This component doesn't render anything
};